import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=2f444cf0&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=2f444cf0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f444cf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f444cf0')) {
      api.createRecord('2f444cf0', component.options)
    } else {
      api.reload('2f444cf0', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=2f444cf0&scoped=true", function () {
      api.rerender('2f444cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Product.vue"
export default component.exports